import "@zalando-internal/z-shop-ui/dist/z-shop-ui.css";
import * as zShopUI from "@zalando-internal/z-shop-ui";
import iconsSvg from "@zalando-internal/z-shop-ui/dist/icons.svg";

// Create SVG container for icons
const wrapper = document.createElement("div");
wrapper.className = "z-svg-res-container";
wrapper.innerHTML = iconsSvg;
// Icons shouldn't have gradients, they may not render them because of hidden div
wrapper.style.display = "none";

// Insert on top of everything in the body to not break the fragment identification
// Polling is needed since document.body is null for hidden tabs in Firefox
const pollForBody = (): void => {
  if (document.body) {
    document.body.insertBefore(wrapper, document.body.firstChild);
  } else {
    setTimeout(pollForBody, 30);
  }
};
pollForBody();

// Export z-shop-ui for legacy compatibility
export { zShopUI as "z-shop-ui" };

// Legacy CommonJS export
if (typeof module !== "undefined" && module.exports) {
  module.exports = {
    "z-shop-ui": zShopUI,
  };
}
